// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CustomerApiModel from "../api-model/CustomerApiModel.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeApiModel(json) {
  var match = json.summary;
  var summary_name = match.name;
  var summary_is_portergold_active = match.is_portergold_active;
  var summary_mobile = match.mobile;
  var summary_address = match.address;
  var summary_city = match.city;
  var summary_uuid = match.uuid;
  var summary_referral = match.referral;
  var summary_is_business_customer = json.is_business_customer;
  var summary = {
    name: summary_name,
    is_portergold_active: summary_is_portergold_active,
    mobile: summary_mobile,
    address: summary_address,
    city: summary_city,
    uuid: summary_uuid,
    referral: summary_referral,
    is_business_customer: summary_is_business_customer
  };
  var decodeAtrributes = function (attr) {
    return {
            attribute_name: attr.attribute_name,
            attribute_value: Belt_Option.getWithDefault(attr.attribute_value, ""),
            is_editable: Belt_Option.getWithDefault(attr.is_editable, false),
            is_verified: Belt_Option.getWithDefault(attr.is_verified, false),
            attribute_note: Belt_Option.getWithDefault(attr.attribute_note, "N/A")
          };
  };
  var decodeGstDetail = function (detail) {
    var millis = detail.updated_at;
    return {
            gstin: Belt_Option.getWithDefault(detail.gstin, ""),
            gst_business_name: Belt_Option.getWithDefault(detail.gst_business_name, ""),
            gst_address: Belt_Option.getWithDefault(detail.gst_address, ""),
            updated_at: millis !== undefined ? Timestamp$Catalyst.toString(Timestamp$Catalyst.make(millis), "DD MMMM YYYY, HH:mm") : ""
          };
  };
  var formData_first_name = decodeAtrributes(json.first_name);
  var formData_last_name = decodeAtrributes(json.last_name);
  var formData_caller_type = decodeAtrributes(json.caller_type);
  var formData_mobile = decodeAtrributes(json.mobile);
  var formData_secondary_mobile = decodeAtrributes(json.secondary_mobile);
  var formData_company_name = decodeAtrributes(json.company_name);
  var formData_port_gold_status = decodeAtrributes(json.port_gold_status);
  var formData_geo_region = decodeAtrributes(json.geo_region);
  var formData_email = decodeAtrributes(json.email);
  var formData_unconfirmed_email = decodeAtrributes(json.unconfirmed_email);
  var formData_gstin = decodeAtrributes(json.gstin);
  var formData_gst_reg_address = decodeAtrributes(json.gst_reg_address);
  var formData_customer_type = decodeAtrributes(json.customer_type);
  var formData_temporarily_deactivated = decodeAtrributes(json.temporarily_deactivated);
  var formData_blacklist_reason = {
    attribute_name: json.blacklist_reason.attribute_name,
    attribute_value: Belt_Option.getWithDefault(json.blacklist_reason.attribute_value, "-1"),
    is_editable: Belt_Option.getWithDefault(json.blacklist_reason.is_editable, false),
    is_verified: Belt_Option.getWithDefault(json.blacklist_reason.is_verified, false),
    attribute_note: Belt_Option.getWithDefault(json.blacklist_reason.attribute_note, "N/A")
  };
  var formData_registration_status = decodeAtrributes(json.registration_status);
  var formData_partload_customer = decodeAtrributes(json.partload_customer);
  var formData_subscribed_for_promo_sms = decodeAtrributes(json.subscribed_for_promo_sms);
  var formData_gstin_list = Belt_Array.map(Belt_Option.getWithDefault(json.gstin_list, []), decodeGstDetail);
  var formData = {
    first_name: formData_first_name,
    last_name: formData_last_name,
    caller_type: formData_caller_type,
    mobile: formData_mobile,
    secondary_mobile: formData_secondary_mobile,
    company_name: formData_company_name,
    port_gold_status: formData_port_gold_status,
    geo_region: formData_geo_region,
    email: formData_email,
    unconfirmed_email: formData_unconfirmed_email,
    gstin: formData_gstin,
    gst_reg_address: formData_gst_reg_address,
    customer_type: formData_customer_type,
    temporarily_deactivated: formData_temporarily_deactivated,
    blacklist_reason: formData_blacklist_reason,
    registration_status: formData_registration_status,
    partload_customer: formData_partload_customer,
    subscribed_for_promo_sms: formData_subscribed_for_promo_sms,
    gstin_list: formData_gstin_list
  };
  return {
          summary: summary,
          formData: formData
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(CustomerApiModel.t_decode(json), "CustomerEntityMapper.re"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
